import componentsComboboxDeviceMultiSelectComboboxEn from "./device-multi-select-combobox/default";
import componentsComboboxPersonMultiSelectComboboxEn from "./person-multi-select-combobox/default";
import componentsComboboxPersonSelectorComboboxEn from "./person-selector-combobox/default";
import componentsComboboxSoftwareSelectorComboboxEn from "./software-selector-combobox/default";

const componentsComboboxEn = {
  noResults: "No results",
  personSelectorCombobox: componentsComboboxPersonSelectorComboboxEn,
  personMultiSelectCombobox: componentsComboboxPersonMultiSelectComboboxEn,
  deviceMultiSelectCombobox: componentsComboboxDeviceMultiSelectComboboxEn,
  softwareSelectorCombobox: componentsComboboxSoftwareSelectorComboboxEn,
  placeAndFleetCombobox: {
    placeholder: "Select place or fleet",
    searchPlaceholder: "Place or fleet name",
  },
};

export default componentsComboboxEn;
